import React from "react";
import { RankingPlayer } from "types/ranking";
import { getAvatarImage } from "utils/avatars";
import "./styles.scss";

import mumiaBronze from "assets/img/mumia_bronze.png";
import mumiaPrata from "assets/img/mumia_prata.png";
import mumiaDourada from "assets/img/mumia_dourada.png";
import bgVideo from "assets/video/bg_tumba.mp4";

interface BannerPodiumTombProps {
  title?: string;
  players: RankingPlayer[];
  isLoading?: boolean;
}

export const BannerPodiumTomb: React.FC<BannerPodiumTombProps> = ({
  title = "Top 3",
  players,
  isLoading = false,
}) => {
  const topThree = [...players];
  while (topThree.length < 3) {
    topThree.push({
      id: `empty-${topThree.length}`,
      name: "---",
      position: topThree.length + 1,
      points: 0,
    });
  }

  const [first, second, third] = topThree.slice(0, 3);
  const podiumOrder = [second, first, third];

  const getTombImage = (position: number): string => {
    switch (position) {
      case 1:
        return mumiaDourada;
      case 2:
        return mumiaPrata;
      case 3:
        return mumiaBronze;
      default:
        return mumiaDourada;
    }
  };

  const getPlayerInitials = (name: string): string => {
    if (!name || name === "---") return "?";
    return name
      .split(" ")
      .map((n) => n[0])
      .join("")
      .toUpperCase()
      .slice(0, 2);
  };

  if (isLoading) {
    return (
      <div className="top3-tomb-podium">
        <video className="ranking-bg-video" autoPlay loop muted playsInline>
          <source src={bgVideo} type="video/mp4" />
        </video>
        <div className="tomb-podium-container relative -mt-[332px]">
          <div className="loading-spinner">
            <div className="spinner"></div>
            <p>Carregando ranking...</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="top3-tomb-podium">
      <video className="ranking-bg-video" autoPlay loop muted playsInline>
        <source src={bgVideo} type="video/mp4" />
      </video>
      <div className="tomb-podium-container relative -mt-[332px]">
        {podiumOrder.map((player, index) => {
          const avatarSrc =
            getAvatarImage(player.fotoDePerfil || player.avatar) ||
            getAvatarImage(player.avatar);
          const isFirstPlace = player.position === 1;

          return (
            <div
              key={player.id}
              className={`tomb-item ${isFirstPlace ? "first-place" : ""}`}
            >
              <div className="tomb-wrapper">
                <div className="position-number">{player.position}</div>
                <img
                  src={getTombImage(player.position)}
                  alt={`${player.position}º Lugar`}
                  className="tomb-image"
                />
                <div className="player-overlay">
                  <div className="player-avatar-container">
                    {avatarSrc ? (
                      <img
                        src={avatarSrc}
                        alt={player.name}
                        className="player-avatar-img"
                      />
                    ) : (
                      <div className="player-avatar-placeholder">
                        {getPlayerInitials(player.name)}
                      </div>
                    )}
                  </div>
                  <div className="player-info">
                    <div className="name-ribbon">
                      <h3 className="player-name">{player.name}</h3>
                    </div>
                    <p className="player-points">
                      {player.points.toLocaleString("pt-BR")} pts
                    </p>
                  </div>
                </div>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};
